import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.AccountBalanceResponse,
  AccountBalance: (params: vp.AccountBalanceRequest) => void,
  AccountBalanceAsync: (params: vp.AccountBalanceRequest) => Promise<vp.AccountBalanceResponse>,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostAccountBalance: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldAccountBalance, setShouldAccountBalance] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.AccountBalanceRequest>({
    PortalUser: '',
    Currency: '',
  });
  const [response, setResponse] = useState<vp.AccountBalanceResponse>({
    Success: false,
    ErrorMessage: '',
    AccountBalance: '',
    AvailableFunds: '',
    AvailableImmediately: '',
    Currency: 'CAD',
    PendingFunds: '',
    Reserve: '',
    RollingReserveNSF: '',
    RollingReserveReturns: '',
  });

  useEffect(() => {
    if (!shouldAccountBalance) return () => {};

    const PostAcocuntBalance = async () => {
      setDataFetchingInfo(true);
      const res = await api.postAccountBalance(params, source);
      setResponse(res);

      setDataFetchingInfo(false);
    };

    if (shouldAccountBalance) void PostAcocuntBalance();
    setShouldAccountBalance(false);
    return () => {
      source.cancel();
    };
  }, [shouldAccountBalance]);

  return [
    response,
    (_params: vp.AccountBalanceRequest) => {
      setParams(_params);
      setShouldAccountBalance(true);
    },
    async (_params: vp.AccountBalanceRequest) => {
      const res = await api.postAccountBalance(_params, source);
      return res;
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        AccountBalance: '',
        AvailableFunds: '',
        AvailableImmediately: '',
        Currency: 'CAD',
        PendingFunds: '',
        Reserve: '',
        RollingReserveNSF: '',
        RollingReserveReturns: '',
      });
      setShouldAccountBalance(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostAccountBalance);
